import { render, staticRenderFns } from "./OutHospital.vue?vue&type=template&id=225ed5f2&scoped=true"
import script from "./OutHospital.vue?vue&type=script&lang=js"
export * from "./OutHospital.vue?vue&type=script&lang=js"
import style0 from "./OutHospital.vue?vue&type=style&index=0&id=225ed5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225ed5f2",
  null
  
)

export default component.exports